'use strict';

var _ = require('underscore'),
  $ = require('jquery'),
  mediator = require('mediatorjs'),
  config = require('../../js/config'),
  utilities = require('../../js/utilities'),
  CarouselBaseView = require('./CarouselBaseView'),

  ThumbnailCarouselView = CarouselBaseView.extend({

    events: {
      'click .ThumbnailCarousel-slide': 'onImageClicked'
    },

    initialize: function(options) {

      this.options = {
        slideClass: '.ThumbnailCarousel-slide',
        slidesToShow: 6,
        slidesToScroll: 1,
        pagination: false,
        infinite: false,
        arrows: true,
        autoplay: false
      };

      if (this.$el.parents('.ThumbnailCarousel.ThumbnailCarousel--vertical').length) {
        this.options.vertical = true;
      }

      // This defines the maximum and minimum screen sizes on which the carousel should be shown
      this.slickMinBreakpoint = 1023;

      if (options.slickMinBreakpoint) this.slickMinBreakpoint = options.slickMinBreakpoint;
      if (options.slickMaxBreakpoint) this.slickMaxBreakpoint = options.slickMaxBreakpoint;

      this.currentSlide = 0;

      if (utilities._isMobileOrTabletDevice()) {
        options.autoplay = false;
        if (ThumbnailCarouselView.__super__.options) {
          ThumbnailCarouselView.__super__.options.autoplay = false;
        }
        if (this.options) {
          this.options.autoplay = false;
        }
      }

      ThumbnailCarouselView.__super__.initialize.call(this, options);
      mediator.on(config.events.ui.resize, _.bind(this.onViewportChange, this));
    },

    slick: function() {
      ThumbnailCarouselView.__super__.slick.call(this);
      this.updateSelected(this.currentSlide);
    },

    onImageClicked: function(ev) {
      this.trigger('select', $(ev.currentTarget).index());
    },

    updateSelected: function(nextIndex) {

      this.currentSlide = nextIndex;

      // If current carousel doesn't have slick component, return
      if (!this.slicked) return;

      var firstSlideShown = this.$el.slick('slickCurrentSlide'),
        lastSlideShown  = firstSlideShown + this.options.slidesToShow - 1;

      // If the element to focus is before the first shown thumbnail, needs to move carousel backward
      if (nextIndex < firstSlideShown) {
        this.$el.slick('slickGoTo', nextIndex);
      }

      // If the element to focus is before the first shown thumbnail, needs to move carousel forward
      if (nextIndex > lastSlideShown) {
      // Since there are several items shown, we need to calculate which one is the first one
        this.$el.slick('slickGoTo', nextIndex - this.options.slidesToShow + 1);
      }

      // Apply classes
      this.$('.ThumbnailCarousel-slide.is-selected').removeClass('is-selected');
      this.$('.ThumbnailCarousel-slide').attr('aria-hidden',true);
      this.$('.ThumbnailCarousel-slide').attr('aria-current',false);
      this.$('.ThumbnailCarousel-slide').eq(nextIndex).addClass('is-selected');
      this.$('.ThumbnailCarousel-slide').eq(nextIndex).attr('aria-hidden', false);
      this.$('.ThumbnailCarousel-slide').eq(nextIndex).attr('aria-current', true);
    }

  });

module.exports = ThumbnailCarouselView;



// WEBPACK FOOTER //
// ./assets/components/Carousel/ThumbnailCarouselView.js